import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Layout } from "@/components/organisms/Layout";
import { Home } from "@/pages/Home";
import { Menu } from "@/pages/Menu";
import { Orders } from "@/pages/Orders";
import { Promotions } from "@/pages/Promotions";
import { PreorderPage } from "@/pages/PreorderPage";
import { PreorderPageExample } from "@/examples";
import { DataLoader } from "@/components/DataLoader";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <DataLoader>
        <Layout />
      </DataLoader>
    ),
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "menu/*",
        element: <Menu />,
      },
      {
        path: "promotions",
        element: <Promotions />,
      },
      {
        path: "orders",
        element: <Orders />,
      },
    ],
  },
  {
    path: "/m/preorder",
    element: (
      <DataLoader>
        <PreorderPage />
      </DataLoader>
    ),
  },
  {
    path: "/examples",
    element: (
      <DataLoader>
        <PreorderPageExample />
      </DataLoader>
    ),
  },
]);

export const AppRouter: React.FC = () => <RouterProvider router={router} />;
